import { useQuery } from '@tanstack/react-query';
import { getAhReport, type AhPayload } from './ahReport';
import { AH_EMPTY } from './ahFixture';

/*
 * Fetches the AH campaign report. If the live call is loading / 404s / errors,
 * we fall back to an ALL-ZERO payload (AH_EMPTY) — the dashboard renders its
 * real structure with 0s rather than example data. The real payload takes over
 * automatically once it loads.
 */
export function useAhReport(reportId: string, baseUrl: string): { data: AhPayload; isPreview: boolean; lastRefreshedAt: string | null } {
  const query = useQuery({
    queryKey: ['ah-report', baseUrl, reportId],
    queryFn: () => getAhReport(reportId, baseUrl),
    retry: false,
  });

  if (query.data) {
    // The real refresh time comes from the report envelope's meta (set by the
    // pipeline on every run) — NOT the payload's baked `campaign.lastUpdated`.
    return { data: query.data.data, isPreview: false, lastRefreshedAt: query.data.meta?.last_refreshed_at ?? null };
  }
  // Loading or errored → zeros (flagged so the UI can show a "no live data" hint).
  return { data: AH_EMPTY, isPreview: true, lastRefreshedAt: null };
}
